import { PropsWithChildren, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectMessage, setMessage } from '../model';
import { DialogHandle } from '@/features/ui-elements/dialog/model';

import { Dialog } from '@/features/ui-elements/dialog/ui';

import cls from './styles.module.pcss';
import buttonCls from '@shared/assets/styles/modules/button.module.pcss'

export function Confirmation({ children }: PropsWithChildren) {
  const { t } = useTranslation();
  const message = useSelector(selectMessage);
  const dispatch = useDispatch();
  const dialogHandle = useRef<DialogHandle>(null);

  function close() {
    dispatch(setMessage(null));
    dialogHandle.current?.close();
  }

  function decline() {
    if (message?.onDecline) {
      message.onDecline();
    }
    close();
  }

  function accept() {
    message?.onAccept();
    close();
  }

  useEffect(() => {
    if (message) {
      dialogHandle.current?.open();
    }
  }, [message]);

  function getContent() {
    if (!message) return null;

    return (
      <div className={cls.Confirmation}>
        <div className={cls.ConfirmationContent}>
          <div className={cls.ConfirmationText}>
            {message.text}
          </div>
          <div className={cls.ConfirmationControls}>
            <button className={buttonCls.ButtonBorder} onClick={decline}>
              {message.declineText || t('common.modals.confirmation.decline')}
            </button>
            <button className={buttonCls.ButtonRed} onClick={accept}>
              {message.acceptText || t('common.modals.confirmation.confirm')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Dialog ref={dialogHandle} content={getContent()}>
      {children}
    </Dialog>
  )
}
